import { QR_CODE_TIME } from '~/constants/common.ts';
import { DiiaStatuses } from '~/store/diia/types.ts';

export const FILES_SIGNING_STATUS_POLL_INTERVAL_MS = 2000;

export const FILES_SIGNING_STATUS_POLL_ATTEMPTS = Math.ceil(
  (QR_CODE_TIME * 1000) / FILES_SIGNING_STATUS_POLL_INTERVAL_MS
);

export const FILES_SIGNING_DIIA_FAILURE_STATUSES = [
  DiiaStatuses.refuse,
  DiiaStatuses.rejected,
  DiiaStatuses.canceled,
  DiiaStatuses.notUsed,
] as const;
